export default __webpack_public_path__ + "static/media/Astronaut-03.313ed7d0.png";